// Sanitize an error stack trace before sending as debug telemetry.
// Strips credential patterns, query strings, and truncates to protect
// secrets that may have leaked into URLs or error messages.
export function sanitizeStack(stack) {
  if (!stack) return '';
  var SECRET_RE = /(key|token|password|auth|secret)=[^\s&)]+/gi;
  var BEARER_RE = /Bearer\s+[A-Za-z0-9._\-]+/gi;
  return (stack || '').split('\n').slice(0, 10).map(function (line) {
    return line
      .replace(SECRET_RE, function (m) { return m.split('=')[0] + '=[REDACTED]'; })
      .replace(BEARER_RE, 'Bearer [REDACTED]')
      .replace(/\?[^\s)#]*/g, '?[REDACTED]')
      .slice(0, 200);
  }).join('\n');
}
